import { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';

const navLinks = [
  { to: '/', label: '首页' },
  { to: '/daily', label: '今日合集' },
  { to: '/about', label: '关于我们' },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [q, setQ] = useState('');
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 10);
    onScroll();
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    setOpen(false);
  }, [location.pathname, location.search]);

  const isActive = (to: string) =>
    to === '/' ? location.pathname === '/' : location.pathname.startsWith(to);

  const submitSearch = (e: React.FormEvent) => {
    e.preventDefault();
    const kw = q.trim();
    navigate(kw ? `/daily?q=${encodeURIComponent(kw)}` : '/daily');
    setQ('');
  };

  return (
    <header
      className={`sticky top-0 z-40 w-full transition-colors duration-300 ${
        scrolled ? 'bg-background-50/95 backdrop-blur border-b border-background-200' : 'bg-background-50 border-b border-background-200/70'
      }`}
    >
      <div className="mx-auto flex h-16 max-w-6xl items-center justify-between px-4 md:px-6">
        <Link to="/" className="flex items-center gap-2 whitespace-nowrap">
          <span className="grid h-9 w-9 items-center justify-center rounded-full bg-primary-500 text-lg text-background-50">
            <i className="ri-news-line"></i>
          </span>
          <span className="flex flex-col leading-none">
            <span className="font-heading text-lg font-black tracking-wide text-foreground-900">吃瓜日报</span>
            <span className="mt-0.5 text-[10px] tracking-[0.18em] text-primary-600">DAILY GOSSIP</span>
          </span>
        </Link>

        <nav className="hidden items-center gap-1 md:flex" aria-label="主导航">
          {navLinks.map((l) => (
            <Link
              key={l.to}
              to={l.to}
              className={`relative px-4 py-2 text-sm whitespace-nowrap transition-colors ${
                isActive(l.to)
                  ? 'font-bold text-primary-700 after:absolute after:inset-x-4 after:-bottom-0.5 after:h-0.5 after:rounded-full after:bg-primary-500'
                  : 'text-foreground-600 hover:text-primary-700'
              }`}
            >
              {l.label}
            </Link>
          ))}
          <Link
            to="/daily?g=redian"
            className="px-4 py-2 text-sm whitespace-nowrap text-foreground-600 hover:text-primary-700"
          >
            社会热点
          </Link>
        </nav>

        <div className="hidden items-center gap-3 lg:flex">
          <form onSubmit={submitSearch} className="flex h-10 items-center gap-2 rounded-full border border-background-300 bg-background-100 px-4 focus-within:border-primary-400">
            <i className="ri-search-line text-base text-foreground-400"></i>
            <input
              value={q}
              onChange={(e) => setQ(e.target.value)}
              placeholder="搜搜今天的热瓜"
              className="w-40 bg-transparent text-sm text-foreground-800 outline-none placeholder:text-foreground-400"
            />
          </form>
          <Link
            to="/about#contact"
            className="grid h-10 items-center rounded-full bg-primary-500 px-5 text-sm font-bold text-background-50 whitespace-nowrap transition-colors hover:bg-primary-600"
          >
            投稿爆料
          </Link>
        </div>

        <button
          onClick={() => setOpen((v) => !v)}
          className="grid h-10 w-10 items-center justify-center rounded-full border border-background-200 text-foreground-700 md:hidden"
          aria-label="打开菜单"
        >
          <i className={open ? 'ri-close-line text-xl' : 'ri-menu-line text-xl'}></i>
        </button>
      </div>

      {open && (
        <div className="border-t border-background-200 bg-background-50 px-4 py-4 md:hidden">
          <form onSubmit={submitSearch} className="mb-3 flex h-11 items-center gap-2 rounded-full border border-background-300 bg-background-100 px-4">
            <i className="ri-search-line text-base text-foreground-400"></i>
            <input
              value={q}
              onChange={(e) => setQ(e.target.value)}
              placeholder="搜搜今天的热瓜"
              className="w-full bg-transparent text-sm outline-none placeholder:text-foreground-400"
            />
          </form>
          <div className="flex flex-col gap-1">
            {navLinks.map((l) => (
              <Link
                key={l.to}
                to={l.to}
                className={`rounded-lg px-4 py-3 text-sm ${
                  isActive(l.to) ? 'bg-primary-100 font-bold text-primary-800' : 'text-foreground-700'
                }`}
              >
                {l.label}
              </Link>
            ))}
            <Link to="/about#contact" className="mt-2 grid h-11 items-center rounded-full bg-primary-500 px-4 text-center text-sm font-bold text-background-50">
              投稿爆料
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}